import React, { useMemo } from 'react'
import { ContentType } from '../../../server/models/GenericContentFields'
import './styles.css'

type Props = {
  type: ContentType
}

export const ContentBadge: React.FC<Props> = ({ type }) => {
  const label = useMemo(() => {
    switch (type) {
      case 'summary':
        return 'THREE SENTENCE SUMMARY'
      case 'blog':
        return 'BLOG OUTLINE'
      case 'carousel':
        return 'CAROUSEL'
      case 'shortVideo':
        return 'SHORT VIDEO SCRIPT'
      default:
        return ''
    }
  }, [type])

  return (
    <div className={`content-badge ${type}`}>
      {label}
    </div>
  )
}
